import { render } from "./SampleIndexFilters.vue?vue&type=template&id=58a2b5dd"
import script from "./SampleIndexFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleIndexFilters.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Sample/SampleIndexFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58a2b5dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58a2b5dd', __exports__)) {
    api.reload('58a2b5dd', __exports__)
  }
  
  module.hot.accept("./SampleIndexFilters.vue?vue&type=template&id=58a2b5dd", () => {
    api.rerender('58a2b5dd', render)
  })

}


export default __exports__